import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import OpenResidentialRegistry from './page/OpenResidentialRegistry';
import ResidentialRegistry from './page/ResidentialRegistry';
import NewsAdminEdit from './page/NewsAdminEdit';
import NewsAdminList from './page/NewsAdminList';
import Mapstat from "./page/Mapstat";
import IndexesPage from './page/IndexesPage';

class App extends Component {


  render() {
    return (
       <BrowserRouter>
          <div>
            <Route exact path='/' component={OpenResidentialRegistry} />
            <Route exact path='/bostadsregistret' component={ResidentialRegistry} />
            <Route exact path='/mapstat' component={Mapstat} />
            <Route exact path='/news/admin/edit' component={NewsAdminEdit} />
            <Route exact path='/news/admin/edit/:news_id' component={NewsAdminEdit} />
            <Route exact path='/news/admin/list' component={NewsAdminList} />
            <Route exact path='/index' component={IndexesPage} />
          </div>
      </BrowserRouter>
    );
  }
}

export default App;
